import { IconProps } from "./";
import Icon from "./assets/help_info_24_bold.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24HelpInfoBold(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
